import type { UsableOfferDto } from "../api/hooks/useOffers";
import type { ExtensionPreviewDto } from "../api/hooks/useStrategySubscriptions";

/** What the year renews at after the new one: an offer with no end runs every year, one with an end is spent. */
export function extensionRenewalUsd(
  preview: ExtensionPreviewDto,
  offer: UsableOfferDto | null,
): number {
  return offer !== null && offer.durationMonths === null ? preview.newYearUsd : preview.yearPriceUsd;
}
